import React, { useState } from 'react';
import { KTSVG } from '../../../../../rbts/helpers';
import { CreateModal } from '../_modals/CreateModal';
import { RemoveModal } from '../_modals/RemoveModal';
import { ListGrid } from './ListGrid';
import { useObtenerTiposPuntoVenta } from '../hooks/TipoPuntoVentaHook';

const View: React.FC = () => {
  const [reloadGrid, setReloadGrid] = useState(Math.random() * 40);
  const [idRow, setIdRow] = useState<number>(0);
  const { data, loadingRequest } = useObtenerTiposPuntoVenta(reloadGrid);

  const [showCreate, setShowCreate] = useState(false);
  const [showRemove, setShowRemove] = useState(false);

  const handleNew = () => {
    setIdRow(0);
    setShowCreate(true);
  };

  const handleEdit = (id: number) => {
    setIdRow(id);
    setShowCreate(true);
  };

  const handleDelete = (id: number) => {
    setIdRow(id);
    setShowRemove(true);
  };

  const handleCloseCreate = (updated: boolean) => {
    if (updated) setReloadGrid(Math.random() * 40);
    setShowCreate(false);
    setIdRow(0);
  };

  const handleCloseRemove = (updated: boolean) => {
    if (updated) setReloadGrid(Math.random() * 40);
    setShowRemove(false);
    setIdRow(0);
  };

  return (
    <>
      <div className="row gy-5 g-xl-8">
        <div className="col-xl-12">
          <div className="card card-xxl-stretch mb-5 mb-xl-12">
            <div className="card-header border-0 pt-5">
              <div className="card-title align-items-start flex-column" />
              <div
                className="card-toolbar"
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                data-bs-trigger="hover"
                title="Nuevo tipo"
              >
                <div
                  className="btn btn-sm btn-light-primary"
                  onClick={handleNew}
                >
                  <KTSVG
                    path="/media/icons/duotune/arrows/arr075.svg"
                    className="svg-icon-5 svg-icon-gray-500 me-1"
                  />
                  Nuevo
                </div>
              </div>
            </div>
            <div className="card-body">
              <div className="row gy-5 g-xl-8">
                <div className="col-xl-12">
                  <ListGrid
                    data={data}
                    loadingGrid={loadingRequest}
                    onEditRegister={handleEdit}
                    onDeleteRegister={handleDelete}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <CreateModal
        id_row={idRow}
        show={showCreate}
        handleClose={handleCloseCreate}
      />

      <RemoveModal
        id_row={idRow}
        show={showRemove}
        handleClose={handleCloseRemove}
      />
    </>
  );
};

export { View };
